export default __webpack_public_path__ + "static/59-b5e68c941dfceb8ff043759b543cd0e7.gif";